<template>
  <el-dialog title="驳回原因" :visible.sync="DialogVisible" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="content">
      <el-input
        v-model.trim="reason"
        type="textarea"
        :rows="5"
        placeholder="请输入驳回原因"
        maxlength="500"
        show-word-limit
        resize="none"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="loading" type="default" @click="handleCancel">取消</el-button>
      <el-button :loading="loading" type="primary" @click="HandleReject">确定</el-button>
    </span>
  </el-dialog>
</template>
<script type="es6">
export default {
  data () {
    return {
      DialogVisible: false,
      reason: '',
      loading: false
    };
  },
  methods: {
    openDialog () {
      this.DialogVisible = true;
      this.loading = false;
      this.reason = '';
    },
    handleCancel () {
      if (this.loading) {
        return;
      }
      this.DialogVisible = false;
    },
    HandleReject () {
      if (this.loading) {
        return;
      }
      const payload = (this.reason || '').trim();
      if (!payload) {
        this.$message && this.$message.warning('请输入驳回原因');
        return;
      }
      this.loading = true;
      this.$emit('HandleReject', { reason: payload, done: this.handleDone });
    },
    handleDone (success = false) {
      this.loading = false;
      if (success) {
        this.DialogVisible = false;
      }
    }
  }
};
</script>
